// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__17qt0","avatar":"style_avatar__1AwNC","menuIcon":"style_menuIcon__2Owv5"};